import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { brand } from "./lib/brand";
// Editor styles load here, before global.css, so our overrides win (lazy-loading them flipped the order).
import "@blocknote/core/fonts/inter.css";
import "@blocknote/mantine/style.css";
import "./styles/global.css";

document.documentElement.dataset.brand = brand.id;
document.title = brand.name;
if (brand.id === "aisthetics") {
  // ฟอนต์ของแบรนด์นี้เท่านั้น (Charmonman = wordmark, Noto Serif Thai = หัวข้อ, IBM Plex = body)
  const fonts = document.createElement("link");
  fonts.rel = "stylesheet";
  fonts.href =
    "https://fonts.googleapis.com/css2?family=Charmonman:wght@700&family=Noto+Serif+Thai:wght@500;600;700&family=IBM+Plex+Sans+Thai:wght@300;400;500;600;700&display=swap";
  document.head.appendChild(fonts);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
